export const HALF_OF_PATH = '/BACKEND/'
